<template>
  <div class="home">
    <v-carousel
      hide-controls
      :hide-delimiters="hideCarouselsControls"
      height="620"
    >
      <v-carousel-item v-for="(item, i) in carousels" :key="i" :src="item.src">
        <v-layout
          align-center
          justify-center
          fill-height
          column
          light
          class="home-title"
        >
          <h1>{{ item.title }}</h1>
          <p class="index-title-text">{{ item.text }}</p>
        </v-layout>
      </v-carousel-item>
    </v-carousel>
    <v-container pa-0 pb-5 id="exclusive">
      <v-layout column align-center justify-center>
        <h2>专属定制</h2>
        <!-- <p>多位保险师悉心甄选，同类产品中只选1至2款</p> -->
      </v-layout>
      <v-layout row wrap class="container-bg group-bg">
        <v-flex md2 sm12 xs12 d-flex align-center>
          <h3></h3>
        </v-flex>
        <v-flex md9 sm12 xs12 mt-5>
          <v-layout row wrap app-bg class="product-item">
            <v-flex xs8 sm8 md3>
              <v-layout row wrap>
                <v-flex d-flex xs12 md12 sm6 class="small-item">
                  <v-layout
                    row
                    pt-4
                    pb-4
                    justify-center
                    style="border-bottom: 1px solid #e0e0e0"
                  >
                    <div>
                      <v-img
                        src="/images/newImg/1.png"
                        max-width="69px"
                        max-height="119px"
                        contain
                      ></v-img>
                      <h4>技术开发</h4>
                    </div>
                   
                    
                  </v-layout>
                </v-flex>
                
                <v-flex d-flex xs12 md12 sm6 class="small-item">
                  <v-layout
                    row
                    pt-4
                    pb-4
                    justify-center
                    style="border-bottom: 1px solid #e0e0e0"
                  >
                    <div>
                      <v-img
                        style="margin: 0 11px"
                        src="/images/newImg/5.png"
                        contain
                        max-width="69px"
                        max-height="119px"
                      ></v-img>
                      <h4>云健康档案</h4>
                    </div>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs8 sm8 md3>
              <v-layout row wrap>
                <v-flex d-flex xs12 md12 sm6 class="small-item">
                  <v-layout
                    row
                    pt-4
                    pb-4
                    justify-center
                    style="border-bottom: 1px solid #e0e0e0"
                  >
                    <div>
                      <v-img
                        src="/images/newImg/2.png"
                        max-width="69px"
                        max-height="119px"
                        contain
                      ></v-img>
                      <h4 style="">系统维护</h4>
                    </div>
                  </v-layout>
                </v-flex>
                <v-flex d-flex xs12 md12 sm6 class="small-item">
                  <v-layout
                    row
                    pt-4
                    pb-4
                    justify-center
                    style="border-bottom: 1px solid #e0e0e0"
                  >
                    <div>
                      <v-img
                        style="margin: 0 18px"
                        src="/images/newImg/6.png"
                        max-width="69px"
                        max-height="119px"
                        contain
                      ></v-img>
                      <h4 style="">家庭医生咨询</h4>
                    </div>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs8 sm8 md3>
              <v-layout row wrap>
                <v-flex d-flex xs12 md12 sm6 class="small-item">
                  <v-layout
                    row
                    pt-4
                    pb-4
                    justify-center
                    style="border-bottom: 1px solid #e0e0e0"
                  >
                    <div>
                      <v-img
                        src="/images/newImg/3.png"
                        max-width="69px"
                        max-height="119px"
                        contain
                      ></v-img>
                      <h4 style="">系统改造</h4>
                    </div>
                  </v-layout>
                </v-flex>
                <v-flex d-flex xs12 md12 sm6 class="small-item">
                  <v-layout
                    row
                    pt-4
                    pb-4
                    justify-center
                    style="border-bottom: 1px solid #e0e0e0"
                  >
                    <div>
                      <v-img
                        src="/images/newImg/7.png"
                        max-width="69px"
                        max-height="119px"
                        contain
                      ></v-img>
                      <h4 style="">医护陪护</h4>
                    </div>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs8 sm8 md3>
              <v-layout row wrap>
                <v-flex d-flex xs12 md12 sm6 class="small-item">
                  <v-layout
                    row
                    pt-4
                    pb-4
                    justify-center
                    style="border-bottom: 1px solid #e0e0e0"
                  >
                    <div>
                      <v-img
                        src="/images/newImg/4.png"
                        max-width="69px"
                        max-height="119px"
                        contain
                      ></v-img>
                      <h4 style="">系统安全</h4>
                    </div>
                  </v-layout>
                </v-flex>
                <v-flex d-flex xs12 md12 sm6 class="small-item">
                  <v-layout
                    row
                    pt-4
                    pb-4
                    justify-center
                    style="border-bottom: 1px solid #e0e0e0"
                  >
                    <div>
                      <v-img
                        src="/images/newImg/8.png"
                        max-width="69px"
                        max-height="119px"
                        contain
                      ></v-img>
                      <h4 style="">健康管理</h4>
                    </div>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      
    </v-container>
    <div class="server-wrap" id="dingZhiFuWu">
      <v-container pa-0>
        <v-layout column align-center justify-center class="light-text">
          <h2>定制服务</h2>
          <p>依托易才服务网络，覆盖全国超400座城市</p>
        </v-layout>
        <v-layout row wrap>
          <v-flex d-flex xs12 md4 justify-center fill-height>
            <section>
              <v-img src="/images/index/service-img1.png"></v-img>
              <div class="service-item">
                <h5>全程管家式服务</h5>
                <h6>7*24小时全程跟踪响应，超级管家“一对一”服务</h6>
              </div>
            </section>
          </v-flex>
          <v-flex d-flex xs12 md4 justify-center fill-height>
            <section>
              <div class="service-item">
                <h5>产品定制化</h5>
                <h6>企业医生服务定制，量身定做解决方案，您身边的企业医务室</h6>
              </div>
              <v-img src="/images/index/service-img2.png"></v-img>
            </section>
          </v-flex>
          <v-flex d-flex xs12 md4 justify-center fill-height>
            <section>
              <v-img src="/images/index/service-img3.png"></v-img>
              <div class="service-item">
                <h5>行业专家</h5>
                <h6>H5、SAAS、API全联接支持，专为企业与员工定制保障产品</h6>
              </div>
            </section>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <div class="app-bg" id="partner">
      <v-container pa-0 pb-5>
        <v-layout column align-center justify-center>
          <h2>合作伙伴</h2>
        </v-layout>
        <v-layout row wrap xs12 justify-center>
          <v-flex v-for="(item, i) in partner" :key="i">
            <img :src="item.src" alt width="133" class="partner-img" />
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <Notice></Notice>
  </div>
</template>

<script>
import Notice from './Notice.vue';
export default {
  data() {
    return {
      carousels: [
        {
          src: "/images/index/banner-1.png",
          title:'服务高效快速链接',
          text:'400+机构(集团)、30+合作渠道、覆盖全国31个省市地区'
        },
        {
          src: "/images/index/banner-2.png",
          title:'全程管家式服务',
          text:'用专业与可靠赢取您的信赖'
        }
      ],
      partner: [
        {
          src: "/images/partner/partner-img1.png"
        },
        {
          src: "/images/partner/partner-img2.png"
        },
        {
          src: "/images/partner/partner-img3.png"
        },
        {
          src: "/images/partner/partner-img4.png"
        },
        {
          src: "/images/partner/partner-img5.png"
        },
        {
          src: "/images/partner/partner-img6.png"
        },
        
      ]
    };
  },
  components: { Notice },
  computed: {
    hideCarouselsControls() {
      return this.carousels.length < 2;
    }
  },
  watch:{
    "$route.hash":{
      handler(hash){
        console.log()
        if(hash != ""){
          this.$nextTick(() => {
           document.getElementById(hash.slice(1)).scrollIntoView(true)
          }); 
        }else{
          window.scrollTo(0,0);
        }
      },
      immediate: true,
      deep: true,
      
    }
  },
};
</script>
<style lang="scss">
.home {
  h2 {
    font-size: 36px;
    margin-bottom: 15px;
    font-weight: 400;
    padding-top: 60px;
  }

  p {
    font-size: 18px;
    color: #666666;
    margin-bottom: 40px;
  }
  .index-title-text {
    font-size: 24px;
    color: #d1d1d1;
  }
  .home-title h1 {
    font-size: 40px;
    margin-bottom: 30px;
  }
}
.container-bg {
  width: 1200px;
  max-height: 420px;
  &.group-bg {
    background: url("/images/index/group-bg.png") no-repeat top center;
    background-size: contain;
    margin-bottom: 50px;
  }
  &.person-bg {
    background: url("/images/index/person-bg.png") no-repeat top center;
    background-size: contain;
  }
  h3 {
    font-size: 30px;
    text-align: center;
    color: #fff;
    font-weight: 600;
    writing-mode: vertical-lr;
    letter-spacing: 5px;
    margin: -40px 76px 0;
  }
  .product-item {
    height: 332px;
    border-left: 1px solid #e0e0e0;
    border-right: 1px solid #e0e0e0;
    section {
      height: 370px;
      padding: 40px 0 0 30px;
      box-sizing: border-box;
      border-right: 1px solid #e0e0e0;
      border-bottom: 1px solid #e0e0e0;
    }
    h4 {
      font-size: 19px;
      margin-bottom: 20px;
    }
    p {
      font-size: 16px;
      color: #666;
      margin-bottom: 0;
    }
  }
  .brb {
    border-right: 1px solid #e0e0e0;
    border-bottom: 1px solid #e0e0e0;
  }
  .blt {
    border-left: 1px solid #e0e0e0;
    border-top: 1px solid #e0e0e0;
  }
}
@media screen and (max-width: 960px) {
  .container-bg {
    width: auto !important;
    max-height: 100% !important;
    .brb {
      border-right: 1px solid #e0e0e0;
      border-bottom: none;
    }
    &.group-bg,
    &.person-bg {
      background-image: none !important;
    }
    .product-item {
      height: 100% !important;
      justify-content: center;
      > .flex {
        border-top: 1px solid #e0e0e0;
      }
      > .flex:first-child {
        border-left: 1px solid #e0e0e0;
      }
    }
    h3 {
      color: #222;
      font-weight: 600;
      letter-spacing: 5px;
      writing-mode: horizontal-tb;
      margin: 0 !important;
    }
  }
  .small-item {
    border-right: 1px solid #e0e0e0;
    &:first-child {
      border-left: 1px solid #e0e0e0;
    }
  }
  .server-wrap {
    section {
      margin-bottom: 30px;
    }
  }
}
@media screen and (max-width: 600px) {
  .home-title {
    h1 {
      font-size: 28px !important;
    }
    p {
      font-size: 18px !important;
    }
  }
  .home {
    h2 {
      font-size: 26px;
      margin-bottom: 18px;
      font-weight: 400;
      padding-top: 50px;
    }

    p {
      font-size: 14px;
      color: #666666;
      margin-bottom: 18px;
    }
    h3 {
      font-size: 20px !important;
    }
  }
  .product-item {
    > .flex:nth-child(2) {
      border-left: 1px solid #e0e0e0;
    }
  }
  .small-item:nth-child(2) {
    border-left: 1px solid #e0e0e0;
  }
}
.server-wrap {
  width: 100%;
  height: 100%;
  background: url("/images/index/server-bg.png") no-repeat center center;
  background-size: cover;
  padding-bottom: 93px;
  p {
    margin-bottom: 53px;
    color: #fff;
  }

  section {
    max-width: 225px;
    background-color: #fff;
  }

  .service-item {
    text-align: center;
    padding: 20px 28px 27px;
    h5 {
      font-size: 16px;
      color: #222;
      margin-bottom: 12px;
      font-weight: 400;
    }
    h6 {
      font-size: 14px;
      color: #666;
      font-weight: normal;
    }
  }
}

.partner-img {
  margin: 0 25px;
  margin-bottom: 45px;
}
.v-btn:not(.v-btn--depressed):not(.v-btn--flat) {
  box-shadow: 0px 3px 1px -2px rgba(255, 255, 255, 0.2),
    0px 2px 2px 0px rgba(255, 255, 255, 0.14),
    0px 1px 5px 0px rgba(255, 255, 255, 0.12);
}
</style>
